import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetWorkflowRuleFieldInputOptionsQueryVariables = GraphQLTypes.Exact<{ [key: string]: never }>;

export type GetWorkflowRuleFieldInputOptionsQueryResult = { __typename?: 'Query' } & {
  workflowRuleFieldInputOptions: Array<
    { __typename?: 'WorkflowRuleFieldType' } & Pick<GraphQLTypes.WorkflowRuleFieldType, 'component' | 'label' | 'name'>
  >;
};

export const GetWorkflowRuleFieldInputOptionsDocument = gql`
  query getWorkflowRuleFieldInputOptions {
    workflowRuleFieldInputOptions {
      component
      label
      name
    }
  }
`;
